<template>
    <svg width="172" height="172" viewBox="0 0 172 172" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M86.0001 28.6667C54.3521 28.6667 28.6668 54.3521 28.6668 86.0001C28.6668
            117.648 54.3521 143.333 86.0001 143.333C117.648 143.333 143.333 117.648 143.333
            86.0001C143.333 54.3521 117.648 28.6667 86.0001 28.6667Z"
            fill="#EB5757"/>
        <path
            d="M113 62.0873L107.643 56L86.4999 80.0264L65.3568 56L60 62.0873L81.1433
            86.1135L60 110.14L65.3568 116.227L86.4999 92.2008L107.643 116.227L113 110.14L91.8568
            86.1135L113 62.0873Z" fill="white"/>
    </svg>
</template>

<script>
export default {
  name: 'icon-erro'
}
</script>

<style>
</style>
